import Dictionary from '@/pages/Admin/Dictionary.vue'
import ManageOrganization from '@/pages/Admin/ManageOrganization.vue'
import ManagePrivileges from '@/pages/Admin/ManagePrivileges.vue'
import DataSources from '../../../pages/Admin/DataSources.vue'
import Municipalities from '@/pages/Admin/Municipalities.vue'
import EmailAuditList from '@/pages/Admin/EmailAuditList.vue'

import WorkflowDesigner from '../../../pages/Admin/Case/WorkflowDesigner.vue'
import Apps from '../../../pages/Admin/Case/Apps.vue'
import Roles from '../../../pages/Admin/Roles.vue'
import AuditTrail from '../../../pages/Admin/AuditTrail.vue'
import SystemSettings from '../../../pages/Admin/SystemSettings.vue'
import Lookups from '../../../pages/Admin/Lookups.vue'
import ContactForm from '../../../pages/Admin/ContactForm.vue'
import QuestionDropDown from '../../../pages/Admin/QuestionDropDown.vue'
import QuestionsBank from '../../../pages/Admin/QuestionsBank/QuestionsList.vue'
import AddQuestion from '../../../pages/Admin/QuestionsBank/AddQuestion.vue'
import EmailTemplatesList from '../../../pages/Admin/EmailTemplates/EmailTemplatesList.vue'
import EditTemplate from '../../../pages/Admin/EmailTemplates/EditTemplate.vue'
import MutlipleSelectDropDown from '../../../components/controls/MutlipleSelectDropDown.vue'
import Hijri from '../../../components/controls/Hijri.vue'
import OldDataTable from '@/pages/Admin/OldDataTable.vue'
import MunicipalitiesDataTable from '@/pages/Admin/MunicipalitiesDataTable.vue'
import ManageELibrary from '@/pages/Admin/ManageELibrary.vue'
import ELibraryCategories from '@/pages/Admin/ELibraryCategories.vue'
import LocationManagement from '@/pages/Admin/LocationManagement.vue'
export default [
    
    {
        name: 'manage-organization',
        path: '/manage-organization',
        component: ManageOrganization,
        meta: {
            secure: true
        }
    },
    {
        name: 'manage-eLibrary',
        path: '/manage-eLibrary',
        component: ManageELibrary,
        meta: {
            secure: true
        }
    },
    {
        name: 'eLibrary-categories',
        path: '/eLibrary-categories',
        component: ELibraryCategories,
        meta: {
            secure: true
        }
    },
    {
        name: 'dictionary',
        path: '/dictionary',
        component: Dictionary,
        meta: {
            secure: true
        }
    },
    {
        name: 'oldData',
        path: '/old-data',
        component: OldDataTable,
        meta: {
            secure: true
        }
    },
    {
        name: 'municipalitiesData',
        path: '/municipalities-data',
        component: MunicipalitiesDataTable,
        meta: {
            secure: true
        }
    },
    {
        name: 'manage-privileges',
        path: '/manage-privileges',
        component: ManagePrivileges,
        meta: {
            secure: true
        }
    },
    
    {
        name: 'data-sources',
        path: '/data-sources',
        component: DataSources,
        meta: {
            secure: true
        }
    },
    {
        name: 'audit-trail',
        path: '/audit-trail',
        component: AuditTrail,
        meta: {
            secure: true
        }
    },
    {
        name: 'system-settings',
        path: '/system-settings',
        component: SystemSettings,
        meta: {
            secure: true
        }
    },
    
   
    
    {
        name: 'workflow-designer',
        path: '/workflow-designer',
        component: WorkflowDesigner,
        meta: {
            secure: true
        }
    },
    {
        name: 'apps',
        path: '/apps',
        component: Apps,
        meta: {
            secure: true
        }
    },
    
    {
        name: 'roles',
        path: '/roles',
        component: Roles,
        meta: {
            secure: true
        }
    },
    {
        name: 'lookups',
        path: '/lookups',
        component: Lookups,
        meta: {
            secure: true
        }
    },
    {
        name: 'QuestionDropDown',
        path: '/QuestionDropDown',
        component: QuestionDropDown,
        meta: {
            secure: true
        }
    },
    {
        name: 'QuestionsBank',
        path: '/QuestionsBank',
        component: QuestionsBank,
        meta: {
            secure: true
        }
    },
    {
        name: 'add-questionsbank',
        path: '/add-questionsbank',
        component: AddQuestion,
        meta: {
            secure: true
        }
    },
    {
        name: 'EmailTemplates',
        path: '/email-templates',
        component: EmailTemplatesList,
        meta: {
            secure: true
        }
    },
    {
        name: 'edit-template',
        path: '/edit-template',
        component: EditTemplate,
        meta: {
            secure: true
        }
    },
    {
        name: 'ContactForm',
        path: '/ContactForm',
        component: ContactForm,
        meta: {
            secure: true
        }
    }, 
    {
        name: 'Municipalities',
        path: '/Municipalities',
        component: Municipalities,
        meta: {
            secure: true
        }
    },
    {
        name: 'location-management',
        path: '/location-management',
        component: LocationManagement,
        meta: {
            secure: true
        }
    },
    {
        name: 'MutlipleSelectDropDown',
        path: '/MutlipleSelectDropDown',
        component: MutlipleSelectDropDown,
        meta: {
            secure: true
        }
    },
    {
        name: 'EmailAuditList',
        path: '/EmailAuditList',
        component: EmailAuditList,
        meta: {
            secure: true
        }
    },
    {
        name: 'Hijri',
        path: '/Hijri',
        component: Hijri,
        meta: {
            secure: true
        }
    }
]